import React from "react";
import { Mutation } from "react-apollo";
import { UPDATE_REGION } from "../../../graphql";
import InputText from "../../UI/Input/Text";
import Text from "../../Type/Text";
import Button from "../../UI/Button";
import { Rowz, Spacer} from "../../Layout/Layout";

class RegionUpdateForm extends React.Component {
  constructor(props) {
    super(props);
    const {
      name,      
      place,
      refNumber
    } = props.regionData;

    console.log("Org ID: " + props.organizationID)

    this.state = {        
        name,
        organizationID: props.organizationID,        
        place,
        refNumber
    };

  }

  handleInputChange = (name, value) => {
    
      this.setState({
        [name]: value
      });
    
  };

  render() {    
    return (
      <Mutation mutation={UPDATE_REGION}>
        {(updateRegion, { data, called, error, loading }) => {
          if (called && !error && !loading) {
            window.location.reload();
          }
          return (
            <form
              onSubmit={e => {
                e.preventDefault();
                console.log("state:" + JSON.stringify(this.state,null,2))
                updateRegion({ variables: { id: this.props.regionID, input: this.state } });
              }}
            >
              <Spacer>
              <Spacer>
                    <Rowz>
                      <Text>Name:</Text>
                      <InputText
                        name="name"
                        value={this.state.name || undefined}
                        placeholder="Hoofddorp Toolenburg"
                        required
                        onChange={value =>
                          this.handleInputChange("name", value)
                        }
                      />
                    </Rowz>
                  </Spacer>                  
                  <Spacer>
                    <Rowz>
                      <Text>Place:</Text>
                      <InputText
                        name="place"
                        value={this.state.place || undefined}
                        placeholder="Zuid"
                        required
                        onChange={value =>
                          this.handleInputChange("place", value)
                        }
                      />
                    </Rowz>
                  </Spacer>
                  <Spacer>
                    <Rowz>
                      <Text>Reference number:</Text>
                      <InputText
                        name="refNumber"
                        value={this.state.refNumber || undefined}
                        placeholder="12345"
                        required
                        onChange={value =>
                          this.handleInputChange("refNumber", value)
                        }
                      />
                    </Rowz>
                  </Spacer>                  

                  <Spacer>
                    <Button type="submit" disabled={loading}>
                      Update
                    </Button>
                  </Spacer>
              </Spacer>
            </form>
          );
        }}
      </Mutation>
    );
  }
}

export default RegionUpdateForm;
